export const DATASETS_LOADING_MESSAGE = 'Loading datasets...';
export const VARIANT_ID_LOADING_MESSAGE = 'Loading variant id...';
export const COLLAPSING_MODELS_LOADING_MESSAGE = 'Loading collapsing models...';
export const ASSOCIATIONS_LOADING_MESSAGE = 'Loading associations...';
export const PHENOTYPE_ID_LOADING_MESSAGE = 'Loading phenotype id...';
export const ASSOCIATIONS_AND_STATISTICS_LOADING_MESSAGE = 'Loading associations and statistics data...';
